form {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

input:not([type="checkbox"]),
button,
.button {
  padding: 0.33em 0.66em;
  border-radius: 100px;
  font-size: inherit;
  font-family: inherit;
}

input:not([type="checkbox"]) {
  box-shadow: inset 0 1px 1px var(--shadow);
  border: none;
  background: var(--fill-strong);
  backdrop-filter: blur(20px);
}

select {
  padding: 0.33em 0.66em;
  margin: -0.33em 0 -0.33em -0.66em;
  border-radius: 100px;
  font-size: inherit;
  font-family: inherit;
  box-shadow: inset 0 1px 1px var(--shadow);
  border: none;
  appearance: none;
  padding-right: 2em;
  background: var(--fill-strong) url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23888' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E") no-repeat right 0.66em center / 1em;
}

input:disabled,
button:disabled {
  opacity: 0.5;
  filter: grayscale() !important;
}

select:disabled.readOnly {
  color: inherit;
}

input:focus-visible {
  outline-color: var(--primary);
}

select {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.fullWidth {
  .field {
    width: 100%;
  }
  input:not([type="checkbox"]), select, textarea {
    width: 100% !important;
  }
}

.field {
  margin-bottom: 1em !important;
  display: flex;
  flex-direction: column;
  gap: 0.25em;
  position: relative;
  min-width: fit-content;
  
  &:last-child {
    margin-bottom: 0 !important;
  }

  label {
    display: block;
    margin-bottom: 0.25em;
    font-size: 0.9em;
    font-weight: 500;
  }

  input:not([type="checkbox"]) {
    width: 100%;
    box-sizing: border-box;
  }

  &.inline {
    margin-bottom: 0;
  }

  .float {
    display: flex;
    position: relative;
    margin-top: 0.75em;
    width: 100%;

    label {
      position: absolute;
      pointer-events: none;
      top: 0em;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 100%;
      left: 0;
      margin: 0;
      display: flex;
      align-items: center;
      font-size: 1em;

      opacity: 0.4;
      width: fit-content;

      transition: all 0.1s ease-in-out !important;
      transform: translateY(-1.1em);
    }

    select:not(:has(option[value='']:checked)):not(.empty) ~ label,
    input:not(:placeholder-shown):not(.empty) ~ label,
    input:focus-visible:not(.empty) ~ label,
    textarea:not(:placeholder-shown):not(.empty) ~ label,
    textarea:focus-visible:not(.empty) ~ label {
      font-size: smaller;
    }

    select:has(option[value='']:checked) ~ label,
    :not(:focus-visible):placeholder-shown ~ label,
    .empty ~ label {
      /*top: 0;*/
      transform: translateY(0);
      height: 100%;
    }

    textarea {
      font: inherit;
      resize: none;
      field-sizing: content;
      min-height: 1.5em;
      max-height: 16em;
    }

    input,
    select,
    textarea {
      /*all:unset;*/
      /*height: 1.75rem;*/
      
      min-width: 13em; /* We don't want it to be smaller than this. */
      /*field-sizing: content; */
      width: 20em;
      
      margin: 0;
      height: auto;
      line-height: 1.5em;
      background: none;
      border-radius: 0;
      border: 0;
      outline: 0;
      box-shadow: none;
      
      padding: 0.125em 0;
      border-bottom: 2px solid var(--border-strong);
      margin-bottom: -2px;
      transition: border-bottom-color 0.25s ease-in-out;

      &.error {
        border-bottom-color: var(--danger-color);
      }

      &[readonly], &:disabled {
        border: 0;
        pointer-events: none;
        /*border-color: transparent;*/
        border-color: var(--border);
      }
      &[type="number"][readonly], &[type="number"]:disabled {
        -moz-appearance: textfield;
        appearance: textfield;

        &::-webkit-inner-spin-button,
        &::-webkit-outer-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
      }
      &.empty {
        font-weight: 500;
        color: transparent;
      }
    }

    select {
      cursor: pointer;
      appearance: none;
      background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23666' d='M6 8L1 3h10z'/%3E%3C/svg%3E")
        no-repeat right center;
      padding-right: 1.5em;
      width: 100%;

      &:disabled {
        cursor: default;
        background: none;
      }
    }

    :focus-visible {
      &::before {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 2px;
        background: red;
        animation: slideIn 0.3s forwards;
      }

      border-bottom-color: var(--faint);
    }
  }
  .inline {
    display: inline-flex;
    align-items: center;
    gap: 0.75em;
  }

  &.checkbox {
    display: flex;
    gap: 0.5em;
    .inline {
      gap: 0.5em;
    }
  }

  div.error {
    font-size: small;
  }

  .inline + div.error {
    margin-top: 0.25em;
    position: absolute;
    width: max-content;
    bottom: -8px;
    transform: translateY(100%);
    backdrop-filter: blur(5px);
    border-radius: 10px;
  }
}

.floatAction {
  margin-top: 0.75em;
  height: 1.75em;
  /*padding: .25em 0 !important;*/
}

.row {
  display: flex;
  align-items: flex-start;
  gap: 0.5em;
}

input.error, select.error {
  outline-style: solid;
  outline-color: var(--danger-color);
  outline-width: 2px;
}

.section {
  margin-top: 2rem;

  > h3:first-child {
    font-size: 1.25rem;
    margin: 1em 0 0.5em;
  }
}

.actions {
  display: flex;
  gap: 1em;
  margin-top: 2em;
}

.submit {
  padding: 0.65em 1.5em;
}

.dropzone {
  border: 2px dashed var(--border-strong);
  border-radius: 4px;
  padding: 2rem;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.2s;

  &:hover {
    border-color: var(--faint);
  }

  &.dropzoneActive {
    border-color: var(--link-color);
    background-color: var(--accent-bg);
  }

  p {
    margin: 0;
    color: var(--muted);
  }
}

.imagePreview {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 1rem;
  margin-top: 1rem;
}

.imagePreviewItem {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0.125rem;

  img {
    width: 100%;
    height: 120px;
    object-fit: cover;
    border-radius: 4px;
    border: 1px solid var(--border-strong);
  }

  small {
    font-size: 0.75rem;
    color: var(--muted);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.imageRemove {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 24px;
  height: 24px;
  background: rgba(220, 38, 38, 0.9);
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;

  &:hover {
    background: rgba(220, 38, 38, 1);
  }
}

.suggestions {
  display: flex;
  gap: 0.5em;
  overflow-x: auto;
  padding: 0.25em 0;
  font-size: x-small;
  color: var(--fg);
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.suggestionPill {
  flex-shrink: 0;
  padding: 0.25em 0.75em;
  color: var(--link-color);
  background: var(--accent-bg);
  border: none;
  border-radius: 1em;
  cursor: pointer;
  font-size: inherit;
  white-space: nowrap;

  &:hover {
    background: var(--fill-strong);
  }
}

label.checkbox {
  font-weight: normal;
  display: inline-flex;
  align-items: center;
  flex-direction: row;
  white-space: nowrap;
  user-select: none;
  gap: 0.2em;
}
